module.exports = __webpack_public_path__ + "img/cmg-labs-4.d77543ec.webp";